import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').TopContributorsReducer>} */
const initialState = [];

/**
 * @param {Array<import('modules/statistics/types').TopContributorsReducer>} _
 * @param {import('modules/statistics/types').FetchTopContributorsStatsSuccessAction} action
 * @returns {Array<import('modules/statistics/types').TopContributorsReducer>}
 */
const updateContent = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_TOP_CONTRIBUTORS_SUCCESS]: updateContent,
});
